var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "120px",
    height: "120px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#131414",
    d: "M 49.5,1.5 C 90.176,-0.155085 113.176,19.1782 118.5,59.5C 116.978,84.0619 105.311,101.895 83.5,113C 51.5865,124.235 26.4198,115.735 8,87.5C -4.28152,60.1397 0.218475,35.973 21.5,15C 30.0037,8.5801 39.337,4.0801 49.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#31f593",
    d: "M 58.5,10.5 C 60.0174,10.5106 61.1841,11.1772 62,12.5C 70.7108,25.935 78.8775,39.6017 86.5,53.5C 77.2967,49.9837 68.13,46.3171 59,42.5C 50.0654,45.7834 41.2321,49.4501 32.5,53.5C 32.1667,53.1667 31.8333,52.8333 31.5,52.5C 40.5106,38.4717 49.5106,24.4717 58.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#32f794",
    d: "M 56.5,48.5 C 58.1992,48.3398 59.8659,48.5065 61.5,49C 70.5833,52.8058 79.5833,56.8058 88.5,61C 80.3324,66.2516 71.9991,71.2516 63.5,76C 61.6354,77.3014 59.6354,77.6347 57.5,77C 48.1667,71.6667 38.8333,66.3333 29.5,61C 38.5599,56.8011 47.5599,52.6344 56.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#31f493",
    d: "M 30.5,69.5 C 30.8966,68.475 31.5632,68.3083 32.5,69C 41.2113,74.6884 50.2113,79.855 59.5,84.5C 69.4844,79.0098 79.4844,73.8431 89.5,69C 79.2799,82.2198 69.4466,95.7198 60,109.5C 50.3897,95.9211 40.5563,82.5877 30.5,69.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.9c3133a1c0885c1cfcccf99f668446a8.svg";
export { ForwardRef as ReactComponent };